import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { OtcThemeProvider } from '@otcmarketsgroup/otcm-ui-lib';
import { ProfileContextProvider } from './context/Profile.context';
import { NotificationsContextProvider } from './context/Notifications.context';
import { AuthProvider } from './context/Auth.context';
import { ThemeProvider } from './context/Theme.context';
import { APP_PREFIX, routes } from './constants';
import { useBroadcastRouteToParent } from './hooks/useBroadcastRouteToParent';
import FormPage from './containers/FormPage';
import CompanyLogoPage from './containers/CompanyLogoPage';
import SuccessPage from './pages/SuccessPage';
import Layout from './components/Layout';
import './styles/otc-theme.scss';

const App = () => {
  const navigate = useNavigate();
  useBroadcastRouteToParent();

  useEffect(() => {
    const handler = (e) => {
      const newPath = e.detail.path.replace(`/${APP_PREFIX}`, '') || '/';
      navigate(newPath, { replace: true });
    };

    window.addEventListener('parent:navigate', handler);
    return () => window.removeEventListener('parent:navigate', handler);
  }, [navigate]);

  const defaultRoutes = [
    {
      path: routes.COMPANY_LOGO,
      element: <CompanyLogoPage />
    },
    {
      path: routes.PROFILE_FORM,
      element: <FormPage />
    },
    {
      path: routes.SUCCESS_PAGE,
      element: <SuccessPage />
    }
  ];

  return (
    <div className='otc-theme company-profile-app'>
      <OtcThemeProvider>
        <ThemeProvider>
          <AuthProvider>
            <NotificationsContextProvider>
              <ProfileContextProvider>
                <Layout>
                  <Routes>
                    {
                      defaultRoutes.map(r => {
                        return (<Route key={r.path} path={r.path} element={r.element} />);
                      })
                    }
                  </Routes>
                </Layout>
              </ProfileContextProvider>
            </NotificationsContextProvider>
          </AuthProvider>
        </ThemeProvider>
      </OtcThemeProvider>
    </div>
  );
};

export default App;
